var _rect, _rect2, _circle, _path, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#f8f9fa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 50,
    width: 200,
    height: 200,
    rx: 10,
    fill: "#ffffff",
    stroke: "#e0e0e0",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 40,
    fill: "#e8f5e9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185 120 L195 130 L215 110",
    stroke: "#2e7d32",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 180,
    width: 140,
    height: 10,
    rx: 5,
    fill: "#e0e0e0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 200,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#e0e0e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature-1.db7d62d07761af3fbbc179017b6243d5.svg";
export { ForwardRef as ReactComponent };